import React, {useState} from 'react';
import TabItem from './TabItem';
import * as S from './TabItem.styles';


const TabItemContainer = (props) => {
	const {children, getActiveTab} = props;
	const [activeTab, setActiveTab] = useState(children[0].props.label)

	const onClickTabItem = (tab) => {
		setActiveTab(tab);
		getActiveTab(tab)
	};

	return (
		<S.TabList className="tab-list">
			{children.map((child) => {
				const { label } = child.props;

				return (
					<TabItem
						activeTab={activeTab}
						key={label}
						label={label}
						onClick={onClickTabItem}
					/>
				);
			})}
		</S.TabList>
	);
}

export default TabItemContainer;